/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { templatesDelete } from "../funcs/templatesDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteTemplateRequest,
  DeleteTemplateSecurity,
} from "../models/operations/deletetemplate.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteTemplateMutationVariables = {
  request?: DeleteTemplateRequest | undefined;
  security?: DeleteTemplateSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteTemplateMutationData = void;

export type DeleteTemplateMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteTemplate templates
 *
 * @remarks
 * Delete prompt template by its ID or name.
 */
export function useDeleteTemplateMutation(
  options?: MutationHookOptions<
    DeleteTemplateMutationData,
    DeleteTemplateMutationError,
    DeleteTemplateMutationVariables
  >,
): UseMutationResult<
  DeleteTemplateMutationData,
  DeleteTemplateMutationError,
  DeleteTemplateMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteTemplateMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteTemplate(): MutationKey {
  return ["@gram/client", "templates", "delete"];
}

export function buildDeleteTemplateMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteTemplateMutationVariables,
  ) => Promise<DeleteTemplateMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteTemplate(),
    mutationFn: function deleteTemplateMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteTemplateMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(templatesDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
